<template>
  <div :class="['micad_icon', getName(name), getSize(size)]">{{message}}</div>
</template>

<script>
export default {
  name: 'Icons',
  props: {
    name: String,
    size: String,
    message: String
  },
  methods: {
   getName(name) {
      if (name !== undefined) {
        return ' micad_icon_'+name
      }
    },
    getSize(size) {
      if (size !== undefined) {
        return ' micad_icon_'+size
      }
    },
  }
};
</script>

